__turbopack_context__.v({
  "activeIndicator": "nISk9q_activeIndicator",
  "activityCutout": "nISk9q_activityCutout",
  "doubtfulEyes": "nISk9q_doubtfulEyes",
  "eye": "nISk9q_eye",
  "focused-eyes": "nISk9q_focused-eyes",
  "gaze": "nISk9q_gaze",
  "happy-greeting": "nISk9q_happy-greeting",
  "happyEyes": "nISk9q_happyEyes",
  "lovingEyes": "nISk9q_lovingEyes",
  "mark": "nISk9q_mark",
  "stop-appear": "nISk9q_stop-appear",
  "surface": "nISk9q_surface",
});
